import { render, staticRenderFns } from "./Quickbooks.template.vue?vue&type=template&id=54c20770&scoped=true&"
var script = {}
import style0 from "./Quickbooks.template.vue?vue&type=style&index=0&id=54c20770&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c20770",
  null
  
)

export default component.exports